import { id } from "date-fns/locale";
import React from "react";
import { getConfig } from "../../../services/environment";
import BaseModal, { BaseModalContent } from "../BaseModal";

function ImageViewer(props) {
  const { isOpen, handleClose, srcImage } = props;

  return (
    <>
      <BaseModal
        title="Images"
        align="center"
        open={isOpen}
        onClose={handleClose}
        fullWidth
        className="modal-header"
      >
        <BaseModalContent>
          <div>
            {srcImage ? (
              <img
                src={srcImage}
                alt="delete"
                style={{ width: "100%", height: "90%" }}
              />
            ) : (
              "Loading..."
            )}
          </div>
        </BaseModalContent>
      </BaseModal>
    </>
  );
}

export default ImageViewer;
